export default __webpack_public_path__ + "static/media/R5C_8173.6e3cc19c.jpg";